import { FirebaseAuth } from '../../firebase'

export class MoisesAuth {
  config: any

  session: any

  constructor(config: any, session: any) {
    this.config = config
    this.session = session
  }

  updateFirebaseToken(token: string): void {
    this.session.token = token
  }

  async signInWithEmailAndPassword({
    email,
    password
  }: {
    email: string
    password: string
  }): Promise<any> {
    // eslint-disable-next-line
    try {
      // Use our Firebase v12 wrapper
      const userCredential = await FirebaseAuth.signInWithEmailAndPassword(
        email,
        password
      )
      const { user } = userCredential

      this.session.user = user

      // Get the ID token using our wrapper
      const token = await user.getIdToken(true)
      if (token) {
        this.updateFirebaseToken(token)
      }

      return user
    } catch (error) {
      throw error
    }
  }
}
